import React, {FunctionComponent} from 'react';
import './InvoiceOptionTab.scss';
import Checkbox from "../../ui-components/Checkbox/Checkbox";

export interface InvoiceOptionTabProps {
    title: string;
    total: string;
    isSelectedTab: boolean;
    isSelectedOption: boolean;
    onSelectOption: () => void;
    onSelectTab: () => void;
}

export const InvoiceOptionTab: FunctionComponent<InvoiceOptionTabProps> = ({
                                                                               title,
                                                                               total,
                                                                               isSelectedTab,
                                                                               isSelectedOption,
                                                                               onSelectOption,
                                                                               onSelectTab
                                                                           }) => {
    return (
        <div onClick={onSelectTab}
             className={`invoice-option-tab${isSelectedTab ? ' invoice-option-tab--selected' : ''}`}>
            <Checkbox checked={isSelectedOption} onChange={onSelectOption} style={{margin: '0 5px'}}/>
            <span className="invoice-option-tab-title">{title}</span>
        </div>
    );
};
